import React, { useState, useEffect } from 'react';

const API_URL = (() => { const envUrl = process.env.REACT_APP_BACKEND_URL; if (!envUrl || envUrl === '') return window.location.origin; try { const envHost = new URL(envUrl).hostname; const currentHost = window.location.hostname; if (currentHost === 'localhost' || currentHost === '127.0.0.1' || envHost === currentHost || currentHost.includes('preview.emergentagent.com')) { return envUrl; } return window.location.origin; } catch (e) { return window.location.origin; } })();

// Light-theme ticker keyframes (blends with the white/slate homepage)
const tickerStyles = `
  @keyframes ticker {
    0% { transform: translateX(0); }
    100% { transform: translateX(-33.333%); }
  }

  .light-ticker {
    background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    border-top: 1px solid #e2e8f0;
    border-bottom: 1px solid #e2e8f0;
  }

  .light-ticker-text {
    font-family: 'Inter', system-ui, sans-serif;
    color: #334155;
    letter-spacing: 0.04em;
    font-weight: 700;
  }

  /* Soft fade masks on both edges so items appear/disappear gently */
  .light-ticker-mask {
    -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);
    mask-image: linear-gradient(90deg, transparent 0, #000 6%, #000 94%, transparent 100%);
  }
`;

const TickerBanner = () => {
  const [messages, setMessages] = useState([
    "FREE Shipping on All Mail-In Repairs & Sales",
    "Same-Day Service Available",
    "Top Dollar for Your Used Devices",
    "Expert Technicians",
    "Apple Independent Repair Provider",
    "Free Diagnostics on All Devices"
  ]);

  useEffect(() => {
    const styleId = 'ticker-keyframes-light';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = tickerStyles;
      document.head.appendChild(style);
    }

    const fetchMessages = async () => {
      try {
        const response = await fetch(`${API_URL}/api/ticker-messages`);
        if (response.ok) {
          const data = await response.json();
          if (data.messages && data.messages.length > 0) {
            setMessages(data.messages);
          }
        }
      } catch (error) {
        // Use default messages if fetch fails
      }
    };
    fetchMessages();
  }, []);

  const duplicatedMessages = [...messages, ...messages, ...messages];

  return (
    <div className="light-ticker" style={{ position: 'relative', width: '100%', height: '44px', zIndex: 10 }} data-testid="ticker-banner">
      <div className="light-ticker-mask relative flex items-center h-full overflow-hidden" style={{ zIndex: 2 }}>
        <div
          className="flex whitespace-nowrap items-center"
          style={{ animation: 'ticker 60s linear infinite' }}
        >
          {duplicatedMessages.map((message, index) => (
            <div key={index} className="flex items-center mx-6 sm:mx-8">
              <span
                className="inline-block w-1.5 h-1.5 rounded-full mr-3 sm:mr-4"
                style={{ background: 'linear-gradient(135deg,#10b981,#14b8a6)' }}
                aria-hidden
              />
              <span className="light-ticker-text text-[12px] sm:text-[13px] uppercase">{message}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TickerBanner;
